import GlobalErrorBoundary from '@di-shared/features/common/GlobalErrorBoundary';

function ErrorPage() {
  return <GlobalErrorBoundary error={null} />;
}

export default ErrorPage;
